<template>
  <div class="h-182 pt-60 pb-60 bg-blue-300 mb-60">
    <h1 class='fw-900 fs-36 mb-fs-28 tc'>
      {{title}}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props:{
    title:{
      type: String,
      default: ''
    },

  },
}
</script>
